import metrics from "../themes/metrics";
export var formatPrice = function (price) {
    var _a;
    var symbol = ((_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currency) || '$';
    return "" + symbol + price.toFixed(2);
};
export var formatNumber = function (amount, fixed) {
    if (fixed === void 0) { fixed = void 0; }
    return "" + amount.toFixed(fixed || 2);
};
export var pxToRem = function () {
    var px = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        px[_i] = arguments[_i];
    }
    var basePx = metrics.baseUnit * 2;
    return px.map(function (num) { return 1 / basePx * num + "rem"; }).join(" ");
};
export var isInViewport = function (element, offset) {
    if (offset === void 0) { offset = 0; }
    if (!element) {
        return false;
    }
    var top = element.getBoundingClientRect().top;
    return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
};
export var scrollIntoViewWithOffset = function (element, offset, behavior) {
    if (behavior === void 0) { behavior = 'auto'; }
    window.scrollTo({
        behavior: behavior,
        top: element.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            offset,
    });
};
export var getBrandName = function () {
    var siteId = window.reactSystemData.siteId;
    if (siteId === 'w3ll-us')
        return 'Well People';
    if (siteId === 'sw-us')
        return 'Keys Soulcare';
    return '';
};
export var buildGAItem = function (product, quantity, index, category, selectedVariant, itemListName) {
    var _a, _b, _c;
    var currency = (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode;
    var promotionalDiscount = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.promoPrice) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.promoPrice) > 0 ? parseFloat((selectedVariant.price - selectedVariant.promoPrice).toFixed(2)) : product.c_promoPrice > 0 ? parseFloat((product.price - product.c_promoPrice).toFixed(2)) : 0;
    var affiliation = getBrandName();
    var item_brand = getBrandName();
    var productObject = {
        item_id: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || product.product_id,
        item_name: product.product_name,
        affiliation: affiliation,
        currency: currency,
        discount: promotionalDiscount,
        index: index || 0,
        item_brand: item_brand,
        item_category: (_b = product.primary_category_id) !== null && _b !== void 0 ? _b : category === null || category === void 0 ? void 0 : category.id,
        item_list_name: itemListName ? itemListName : (_c = category === null || category === void 0 ? void 0 : category.id) !== null && _c !== void 0 ? _c : '',
        price: selectedVariant && selectedVariant.price ? selectedVariant.price : product.price,
        quantity: quantity
    };
    if (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color) {
        productObject.item_variant = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color;
    }
    return productObject;
};
export var cookieCategoryIsAllowed = function (category) {
    var _a, _b, _c;
    if (!window.SitePreferences.ENABLE_ONETRUST_BANNER) {
        return true;
    }
    var allowedGroups = [(_a = window.OneTrustCookieInfo) === null || _a === void 0 ? void 0 : _a.groups.strictly_necessary];
    if ((_b = window.OnetrustActiveGroups) === null || _b === void 0 ? void 0 : _b.length) {
        allowedGroups = window.OnetrustActiveGroups.replace(/^,|,$/g, '').split(',');
    }
    else if ((_c = window.OneTrustCookieInfo) === null || _c === void 0 ? void 0 : _c.consentCookieObject) {
        allowedGroups = window.OneTrustCookieInfo.consentCookieObject.groups;
    }
    return allowedGroups.indexOf(category.toString()) > -1;
};
export var decodeHTMLEntities = function (text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
};
//# sourceMappingURL=index.js.map